import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-2xl font-medium text-gray-900" }
const _hoisted_2 = { class: "text-sm" }
const _hoisted_3 = { class: "mt-4" }
const _hoisted_4 = { class: "flex items-center mt-3 text-sm text-brand-600" }
const _hoisted_5 = { class: "mx-auto" }

import { 
		Auth
	} from '@/api/Auth'

	import { 
		useI18n
	} from 'vue-i18n'

	import {
		useRouter
	} from 'vue-router'
	
	import { 
		ref
	} from 'vue'

	
	const __default__ = { name: 'ResetPasswordForm' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

	const {t} = useI18n()

	const router = useRouter()
	const email = ref("")
	const resetLoading = ref(false)

	async function resetPassword() { 
		resetLoading.value = true
		if (email.value == "") {
			document.getElementById('email')?.focus()
			return
		}

		try {
			await Auth.forgotPassword(email.value)
			resetLoading.value = false
			router.push({name: 'ResetPasswordSuccess'})
		}
		catch(e) {
			console.log(e)
			resetLoading.value = false
			// do something with the error
		}
	}

return (_ctx: any,_cache: any) => {
  const _component_tw_input = _resolveComponent("tw-input")!
  const _component_tw_button = _resolveComponent("tw-button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("h1", _hoisted_1, _toDisplayString(_unref(t)('resetPassword.resetYourPassword')), 1)
    ]),
    _createElementVNode("form", {
      class: "mt-8",
      onSubmit: _withModifiers(resetPassword, ["prevent"])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_tw_input, {
          modelValue: email.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
          id: "email",
          required: true,
          type: "email",
          label: _unref(t)('resetPassword.email'),
          validation: _unref(t)('login.emailValidation'),
          class: "text-md"
        }, null, 8, ["modelValue", "label", "validation"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_tw_button, {
          class: "w-full btn-brand font-medium",
          disabled: resetLoading.value,
          type: "submit"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('resetPassword.submit')), 1)
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_router_link, {
            class: "link",
            to: {name: 'Login'}
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('resetPassword.returnToLoginScreen')), 1)
            ]),
            _: 1
          })
        ])
      ])
    ], 32)
  ], 64))
}
}

})